import React from 'react';
import classNames from 'classnames';

import Button from 'src/components/ui/button';

import useCookies from 'src/hooks/use-cookies';
import useUnmountAnimation from 'src/hooks/use-unmount-animation';
import { LOCALES } from 'src/constants';
import { acceptCookies, rejectCookies } from 'src/utils';
import type { PopupCookiesProps } from './popup-cookies.props';

const PopupCookies = ({ setEnableCookies }: PopupCookiesProps) => {
  const { shouldShowPopupCookies, setShouldShowPopupCookies } = useCookies();
  const { handleAnimationEnd, isUnmounting, unmountComponent } = useUnmountAnimation(() =>
    setShouldShowPopupCookies(false)
  );

  const handleAcceptCookiesButtonClick = () => {
    setEnableCookies(true);
    acceptCookies();
    unmountComponent();
  };

  const handleRejectButtonClick = () => {
    setEnableCookies(false);
    rejectCookies();
    unmountComponent();
  };

  return shouldShowPopupCookies ? (
    <div
      className={classNames('popup popup_cookies', isUnmounting && 'popup_hiding')}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className="popup__header">
        <p className="popup__title">{LOCALES.THIS_WEBSITE_USES_COOKIES}</p>
        <p className="popup__text">{LOCALES.ON_OUR_WEBSITE_WE_USE_COOKIE}</p>
      </div>

      <div className="popup__buttons">
        <Button
          className="popup__button"
          isDisabled={isUnmounting}
          label={LOCALES.ACCEPT_COOKIES}
          onClick={handleAcceptCookiesButtonClick}
          size="normal"
          tag="button"
          theme="filled"
        />

        <Button
          className="popup__button"
          isDisabled={isUnmounting}
          label={LOCALES.REJECT}
          onClick={handleRejectButtonClick}
          size="normal"
          tag="button"
          theme="outlined"
        />
      </div>
    </div>
  ) : null;
};

export default PopupCookies;
